import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// Dev only: third-party Elfsight widgets trigger the benign Chrome warning
// "ResizeObserver loop completed with undelivered notifications", which the
// webpack-dev-server overlay shows as a fatal error. Deferring observer
// callbacks to the next frame avoids the loop. Production is unaffected.
if (process.env.NODE_ENV === 'development' && window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
